import { render, staticRenderFns } from "./discount-rate-product-list.vue?vue&type=template&id=3ddb9dc4&scoped=true&"
import script from "./discount-rate-product-list.vue?vue&type=script&lang=js&"
export * from "./discount-rate-product-list.vue?vue&type=script&lang=js&"
import style0 from "./discount-rate-product-list.vue?vue&type=style&index=0&id=3ddb9dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb9dc4",
  null
  
)

export default component.exports